export const FAMILY_INSTRUCTIONAL_CALENDAR_URL = 'https://airreading.com/calendar';
export const FAMILY_SCHEDULING_ADMIN_EMAIL = 'admin@airclubhouse.com';
export const FAMILY_MANAGE_MEMBERSHIP_URL = 'https://billing.stripe.com/p/login/14k8Aqc9D0u44EgeUU';
